// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"540dc959","10":"a693dbf7","164":"d130bf31","172":"5468afe1","208":"772fc7d0","217":"45b644fa","395":"2756048e","422":"bb442857","424":"c76db3bd","453":"00dc83a5","563":"2ff6be91","673":"aaf59c19","965":"d6ffbb2a"}[chunkId] + ".chunk.js";
};